export const org = {
  name: "👴 CEO",
  children: [
    {
      name: "🧔 Dir. Finance",
      children: [
        {
          name: "🧑 Finance Exec",
        },
      ],
    },
    {
      name: "👩‍🦱 Dir. Engineering",
      children: [
        {
          name: "👩 Team Lead",
          children: [
            {
              name: "👱 Frond-End(ReactJS)",
            },
            {
              name: "👩‍🦳 Back-End(Node.js)",
            },
          ],
        },
      ],
    },
    {
      name: "👱‍♀️ Dir. HR",
    },
  ],
};
